<template>
  <div>
    <div v-if="subtitle && subtitle.length">{{ subtitle }}</div>
    <div :data-cy="dataCy" v-html="text"></div>
    <div v-if="isOrderOthers" class="mt-6">
      <div class="mb-2" v-html="additionalInfoText"></div>
      <InfoList :items="additionalInfoItems" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DashboardFormFinal',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    },
    text: {
      type: String,
      required: true
    },
    additionalInfoText: {
      type: String,
      default: ''
    },
    additionalInfoItems: {
      type: Array,
      default: () => []
    },
    dataCy: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      isOrderOthers: false
    };
  },
  beforeDestroy() {
    this.setDialogLeftHeaderIconType('static');
    this.setDialogLeftHeaderIconComponent('');
  },
  mounted() {
    // TODO: časem upravit na lepší řešení @Jarda
    // vyberu step, ve kterém má být výběr pacienta
    const applicableFormStep = this.$store.state.dynamicForms.forms.Order?.formSteps.find(
      step => step.formStepType === 'select_patient'
    );

    // vyberu konkrétní input ze stepu
    const applicableFormInput = applicableFormStep?.formInputs?.find(
      input => input.identifier === 'which_person_order'
    );

    if (applicableFormInput) {
      // pokud existuje step s inputem, najdu si id hodnoty, která odpovídá vyběru "někdo jiný"
      const relatableValueId = applicableFormInput.values.find(
        value => value.htmlClass === 'others'
      )?.id;
      if (relatableValueId) {
        // nastavím data na hodnotu podle toho, zda se odpověď na tento input rovná odpovědi "někdo jiný"
        this.isOrderOthers =
          this.$store.state.dynamicForms.responses.Order[applicableFormInput.id] ===
          relatableValueId;
        return;
      }
    }
    this.isOrderOthers = false;

    this.updateDialogButtons([
      {
        events: {
          click: () => {
            this.$emit('close');
          }
        },
        text: this.isOrderOthers ? this.$t('finish') : this.$t('done')
      }
    ]);
    this.updateDialogTitle(this.title);
    this.updateHeaderType('information');
    this.updateDialogLeftHeaderIcon('');
    this.setDialogLeftHeaderIconType('animated');
    this.setDialogLeftHeaderIconComponent('Confetti');
  },
  methods: {
    ...mapActions({
      updateDialogButtons: 'dynamicForms/updateDialogButtons',
      updateDialogTitle: 'dynamicForms/updateDialogTitle',
      updateHeaderType: 'dynamicForms/updateHeaderType',
      updateDialogLeftHeaderIcon: 'dynamicForms/updateDialogLeftHeaderIcon',
      setDialogLeftHeaderIconType: 'dynamicForms/setDialogLeftHeaderIconType',
      setDialogLeftHeaderIconComponent: 'dynamicForms/setDialogLeftHeaderIconComponent'
    })
  }
};
</script>
